import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { CustomerServiceRequirementRoutingModule } from './customer-service-requirement-routing.module';
import { CustomerServiceRequirementListComponent } from './customer-service-requirement-list/customer-service-requirement-list.component';
import { CustomerServiceRequirementFormComponent } from './customer-service-requirement-form/customer-service-requirement-form.component';
import { CsrRemarkDialogComponent } from './csr-remark-dialog/csr-remark-dialog.component';

@NgModule({
  declarations: [
    CustomerServiceRequirementListComponent,
    CustomerServiceRequirementFormComponent,
    CsrRemarkDialogComponent
  ],
  imports: [
    CommonModule,
    CustomerServiceRequirementRoutingModule,
    AngularMaterialModule,
    SharedModule,
    ReactiveFormsModule,
    FormsModule
  ]
})
export class CustomerServiceRequirementModule { }
